<style></style>

<template>
    <div class="action-plan-list-item">
        <div class="ap-row">
            <div class="ap-icon">
                <module-icon :module-slug="module.slug"></module-icon>
            </div>
            <div class="ap-text-dates">
                <div class="ap-text" v-html="actionPlan.goal.text">
                </div>
                <div class="started-completed">
                    <div class="ap-started" v-if="actionPlan.date_started">Start Date: {{ formatDate(actionPlan.date_started) }}</div>
                    <div class="ap-completed" v-if="actionPlan.date_completed">Completion Date: {{ formatDate(actionPlan.date_completed) }}</div>
                </div>
            </div>
            <div class="ap-buttons">
                <a :href="$basePath+'/action-plans/'+actionPlan.id" class="btn-orange-blue btn-sm module-view d-block mb-2">
                    {{buttonText}}
                    <!-- <span v-if="actionPlan.date_completed === null">View/Update Action Plan</span>
                    <span v-else>View Action Plan</span> -->
                </a>
                <a :href="$basePath+'/tips-and-materials/'+module.slug+'/'+actionPlan.goal.best_practice.section.slug" class="btn-orange-blue btn-sm module-view d-block">
                    Related Tips &amp; Materials
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import ModuleIcon from '../ModuleIcon'
    
    export default {
        components: {
            ModuleIcon,
        },
        props: [
            'actionPlan',
            'module'
        ],
        data() {
            return {}
        },
        computed: {
            buttonText: function () {
                if (this.actionPlan.date_started === null) {
                    return 'Start Action Plan';
                }
                if (this.actionPlan.date_completed === null) {
                    return 'View/Update Action Plan';
                }
                return 'View Action Plan';
            }
        },
        methods: {
            formatDate: function (dateString) {
                if (dateString === null) {
                    return null
                }
                return moment(dateString).format('MM/DD/YYYY')
            }
        }
    
}
</script>